/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {GetterTree} from 'vuex';
import {RootState} from '@/store/types';
import {UgcBuildStateInterface, UgcRevisionInterface} from '@/store/modules/ugc-build/types';
import {UgcItemInterface} from '@/store/modules/ugc-item/types';

/**
 * The UGC (item) build module getters provide entry points for stored data.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const getters: GetterTree<UgcBuildStateInterface, RootState> = {
    /**
     * Determines if an item has been selected.
     *
     * @param {UgcBuildStateInterface} state
     *
     * @returns {UgcRevisionInterface[]}
     */
    revisions(state: UgcBuildStateInterface): UgcRevisionInterface[] {
        return state.revisions;
    },

    /**
     * Check that the state has revisions.
     *
     * @param {UgcBuildStateInterface} state
     *
     * @returns {boolean}
     */
    hasRevisions(state: UgcBuildStateInterface): boolean {
        return state.revisions && state.revisions.length > 0;
    },


    /**
     * Gets the item (if available).
     *
     * @param {UgcBuildStateInterface} state
     * @returns {UgcItemInterface | undefined}
     */
    item(state: UgcBuildStateInterface): UgcItemInterface|undefined {
        return state.item;
    },

    /**
     * Get last revision.
     *
     * @param {UgcBuildStateInterface} state
     *
     * @returns {UgcRevisionInterface | undefined}
     */
    lastRevision(state: UgcBuildStateInterface): UgcRevisionInterface | undefined {
        return state.revisions[0] || undefined;
    },

    /**
     * Get the most recent item with the provided state.
     *
     * @param {UgcBuildStateInterface} state
     *
     * @returns {(name: string) => (UgcRevisionInterface | undefined)}
     */
    mostRecentItem(state: UgcBuildStateInterface): (name: string) => UgcRevisionInterface|undefined {
        return (name: string): UgcRevisionInterface|undefined => {
            return state.revisions.find((revision: UgcRevisionInterface) => {
                return revision.status === name;
            });
        };
    },
};
